// src/features/knowledge-management/hooks/useTassonomie.js
//
// Tassonomie di settore (SEC-) e dominio funzionale (DOM-) — AF v2.0 §6,
// tabelle di Esperienza — e valori dei filtri della lista (UC-KM-01), da
// GET /esperienze/filtri. Il backend confronta i filtri per codice: se
// l'apertura salvasse testo libero, la lista non troverebbe nulla.

import { useEffect, useState } from 'react';
import { useKmClient } from '../../../lib/useKmClient.js';

export function useFiltriEsperienze() {
  const kmClient = useKmClient('km');
  const [dati, setDati] = useState(null);
  const [stato, setStato] = useState('loading'); // loading | ready | error

  useEffect(() => {
    let annullato = false;
    kmClient
      .get('/esperienze/filtri')
      .then((d) => { if (!annullato) { setDati(d || {}); setStato('ready'); } })
      .catch(() => { if (!annullato) setStato('error'); });
    return () => { annullato = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { filtri: dati, stato };
}

// Confronto tollerante dei codici: «SEC-001-03», «SEC001-03» e «sec001» sono
// lo stesso codice (i dati storici non sempre hanno i trattini).
const normCodice = (c) => String(c || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

// Nome leggibile di un codice L1 o L2 («SEC-001-03» → «Giustizia»).
// Se il codice non è nella tassonomia restituisce '' (mai il codice grezzo
// sullo schermo: i codici non sono comprensibili per chi usa la pagina).
export function nomeLeggibile(albero, codice) {
  if (!codice || !Array.isArray(albero)) return '';
  const k = normCodice(codice);
  for (const l1 of albero) {
    if (normCodice(l1.codice) === k) return l1.nome;
    const l2 = (l1.livello_2 || []).find((x) => normCodice(x.codice) === k);
    if (l2) return l2.nome;
  }
  return '';
}

// Nome usato dalle pagine di dettaglio. Prima, se il codice non era nella
// tassonomia, mostrava il codice grezzo: ora restituisce '' e la pagina
// mostra «—». Compatibile con i chiamanti esistenti.
export function nomeDaCodice(albero, codice) {
  return nomeLeggibile(albero, codice);
}
